import GenericDB from './generic-db';

export default class AssessmentTypeFieldGroupsDB extends GenericDB {
  constructor() {
    super('assessmentTypeFieldGroups');
  }
}
